import PropTypes from 'prop-types';
import React from 'react';
import ShopForm from '../../../main/shops/shopForm';
import SimpleHeader from '../../../main/headers/simpleHeader';
import {
  getInitialEmptyValues,
} from '../../../common/helpers/shops';
import { withInjectFeatureFlagsToProps, flagNames } from '../../../../modules/infra/feature-flags';

const AddShop = ({ saveShop, router, useDefaultAutoPayoutFeeValues }) => {
  const saveAndRedirect = data => saveShop(data).then(() => router.push('/admin/shops'));
  return (
    <div>
      <SimpleHeader heading="Add shop" />
      <ShopForm
        saveUpdatedShop={saveAndRedirect}
        initialValues={getInitialEmptyValues({
          useDefaultAutoPayoutFeeValues,
        })}
        cancelHref="/admin/shops"
      />
    </div>
  );
};

AddShop.propTypes = {
  saveShop: PropTypes.func.isRequired,
  router: PropTypes.object,
  useDefaultAutoPayoutFeeValues: PropTypes.bool.isRequired,
};

// TODO remove when flagNames.AUTOPAYOUT_SELF_SERVE is removed
export default withInjectFeatureFlagsToProps([{
  name: flagNames.AUTOPAYOUT_SELF_SERVE,
  as: 'useDefaultAutoPayoutFeeValues',
}])(AddShop);
